import { ListboxOption } from "@headlessui/react";
import clsx from "clsx";
import Icon from "../Icon";
import { SelectOptionProps } from "./types";

const SingleSelectOption = <T,>({
  children,
  value,
  size,
}: SelectOptionProps<T>) => {
  return (
    <ListboxOption value={value}>
      {({ active, selected }) => (
        <div
          className={clsx(
            "cursor-pointer px-s py-2xs w-full flex justify-between items-center hover:bg-neutral-12",
            {
              "bg-neutral-25": active,
              "bg-neutral-12": selected,
              "text-body-2": size === "md",
              "text-app-body-2": size === "sm",
            },
          )}
        >
          <span className="whitespace-nowrap text-ellipsis overflow-hidden">
            {children}
          </span>
          {selected && (
            <Icon type="Check" className="text-primary-800 ml-2xs" size={20} />
          )}
        </div>
      )}
    </ListboxOption>
  );
};

const MultiSelectOption = <T,>({
  children,
  value,
  size,
}: SelectOptionProps<T>) => {
  return (
    <ListboxOption value={value}>
      {({ active, selected }) => (
        <div
          className={clsx(
            "cursor-pointer px-s py-2xs w-full flex items-center group hover:bg-neutral-12",
            {
              "bg-neutral-25": active,
              "bg-neutral-12": selected,
              "text-body-2": size === "md",
              "text-app-body-2": size === "sm",
            },
          )}
        >
          <span
            className={clsx(
              "flex-none mr-2xs border rounded-xs  flex justify-center items-center text-neutral-0",
              {
                "bg-primary-800 border-primary-800 group-hover:bg-primary-825 group-hover:border-primary-825 group-active:bg-primary-850 group-active:border-primary-850 ":
                  selected,
                "bg-neutral-0 border-neutral-150 group-hover:border-primary-825 group-active:border-primary-850":
                  !selected,
                "w-2s h-2s": size === "sm",
                "w-3s h-3s": size === "md",
              },
            )}
          >
            {selected && <Icon type="Check" size={size === "sm" ? 14 : 16} />}
          </span>
          <span className="whitespace-nowrap text-ellipsis overflow-hidden">
            {children}
          </span>
        </div>
      )}
    </ListboxOption>
  );
};

const SelectOption = <T,>({ multiple, ...props }: SelectOptionProps<T>) => {
  if (multiple) {
    return <MultiSelectOption {...props} />;
  }
  return <SingleSelectOption {...props} />;
};

export default SelectOption;
